import { CSSProperties } from 'react';

export const mainButtonContainer = (fixed?: boolean): CSSProperties => ({
  minHeight: '7%',
  ...(fixed
    ? {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '5px 18px 15px 18px'
      }
    : {})
});

export const mainButtonStyle: CSSProperties = {
  width: '100%',
  height: '50px',
  color: '#fff',
  border: 'none',
  borderRadius: '12px',
  fontSize: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  appearance: 'none',
  fontWeight: 500,
  marginBottom: '10px'
};
